import React, { useEffect, useState } from 'react';
import i18n from 'I18n';
import CustomSwitchButton from 'component/base/CustomSwitchButton';

const OtherInfoToggleField = ({
  language,
  isConfirm,
  defaultValue,
  fieldName,
  editAction,
}) => {
  const [inputValue, setInputValue] = useState(!!defaultValue);

  const onEdit = (value) => {
    editAction(fieldName, value);
  };

  useEffect(() => {
    // init value
    setInputValue(!!defaultValue);
    onEdit(!!defaultValue)
  }, [defaultValue]);

  return (
    <div>
      <CustomSwitchButton
        defaultChecked={inputValue}
        onChange={(isChecked) => {
          onEdit(isChecked)
        }}
        disabled={isConfirm}
      />
    </div>
  );
};

export default OtherInfoToggleField;
